import axios from '@axios'

export default {
    fetch(queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('workShifts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne({ id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`workShifts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(data) {
      return new Promise((resolve, reject) => {
        axios.post('workShifts', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(form) {
      return new Promise((resolve, reject) => {
        axios.put(`workShifts/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    delete(id) {
      return new Promise((resolve, reject) => {
        axios.delete(`workShifts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
}
